import { __awaiter, __generator } from "tslib";
import 'promise-polyfill/src/polyfill';
import * as React from 'react';
import { render } from 'react-dom';
import feedLoader from 'shared/feed/feedLoader';
import { siteInfoLoader } from 'shared/siteInfo/siteInfoLoader';
import { trackingLoader } from 'shared/tracking/trackingLoader';
import AdContainer from './components/AdContainer';
import './polyfills';
import setPublicPath from './setPublicPath';
// Ensure dynamic imports are referenced
// absolutely when in hosted, production mode.
setPublicPath();
var appInit = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // Retrieve additional site info if available.
            return [4 /*yield*/, siteInfoLoader()];
            case 1:
                // Retrieve additional site info if available.
                _a.sent();
                // transform ad data for feed content
                return [4 /*yield*/, feedLoader()];
            case 2:
                // transform ad data for feed content
                _a.sent();
                // preload tracking before rendering app
                return [4 /*yield*/, trackingLoader()];
            case 3:
                // preload tracking before rendering app
                _a.sent();
                render(React.createElement(AdContainer, null), document.querySelector('#root'));
                return [2 /*return*/];
        }
    });
}); };
appInit();
